import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const RouteKmReportPage = lazy(() => import('@pages/routeDistances/RouteKmReportPage'));

const RouteKmReportRouteContainer = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('route-km-report-page-title')}>
        <RouteKmReportPage />
      </PageWrapper>
    </Suspense>
  );
};

export default { RouteKmReportRouteContainer };
